import { render, staticRenderFns } from "./CardContainer.vue?vue&type=template&id=a97108d2&"
import script from "./CardContainer.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CardContainer.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./CardContainer.vue?vue&type=style&index=0&id=a97108d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports